import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default class extends Controller {
  static targets = [ 'emptyMessage', 'container' ];
  static values = { amount: Number };

  connect() {
    this.updateEmptyMessage();
    this.element.querySelector('a.add-row').addEventListener('add-row:appended', () => {
      this.bindSelect2();
      this.amountValue += 1;
    });
    this.bindSelect2();
  }

  bindSelect2() {
    $(this.element.querySelectorAll('.select2')).select2({
      placeholder: '-- selecione --',
      allowClear: false,
      multiple: false,
      escapeMarkup: (markup) => markup
    });
  }

  remove(ev) {
    let $row = ev.currentTarget.closest('.row, .line'),
      inputName = $row.dataset.objectName;
    this.askConfirmation().then((result) => {
      if (result.value) {
        this.containerTarget.insertAdjacentHTML('beforeend', `
          <input type="hidden" name="${inputName}[id]" value="${$row.dataset.objectId}" />
          <input type="hidden" name="${inputName}[_destroy]" value="1" />
        `);
        $row.remove();
        this.amountValue -= 1;
        this.containerTarget.dispatchEvent(new CustomEvent("remove-row:detached"));
        return;
      }
    })
  }

  askConfirmation() {
    return Swal.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      html: "Deseja realmente <b>remover</b> esse registro?",
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  amountValueChanged() {
    this.updateEmptyMessage();
  }

  updateEmptyMessage() {
    this.emptyMessageTarget.classList.toggle('hidden', this.amountValue > 0);
    this.containerTarget.classList.toggle('hidden', this.amountValue == 0);
  }
}